import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Table from "components/Admin/Brands/Brands";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import { useDispatch, useSelector } from "react-redux";
import {
  updateBrand,
  getBrands,
  deleteBrand,
  createBrand,
} from "store/actions/brands";

const Brands = () => {
  const brandsData = useSelector((state) => state.brands.brands);
  const allCategories = useSelector((state) => state.brands.categories);
  const dispatch = useDispatch();
  const [page, setPage] = useState(brandsData ? brandsData.pag.page : 1);
  const [amount, setAmount] = useState(brandsData ? brandsData.pag.amount : 10);
  const [orderField, setOrderField] = useState(
    brandsData ? brandsData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    brandsData ? brandsData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    brandsData ? brandsData.pag.search_by : "name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getBrands(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  const deleteHandler = (id) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(deleteBrand(id, pag, history));
  };
  const createHandler = (newData) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(createBrand(newData, pag, history));
  };
  const updateHandler = (newData) => {
    const pag = {
      page,
      amount,
      order_field: orderField,
      order_type: orderType,
      search_value: searchValue,
      search_by: searchBy,
    };
    dispatch(updateBrand(newData, pag, history));
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Brand Table</h4>
        </CardHeader>
        <CardBody>
          {brandsData && (
            <Table
              rows={brandsData.data}
              totalRows={brandsData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              //
              createHandler={createHandler}
              updateHandler={updateHandler}
              deleteHandler={deleteHandler}
              categories={allCategories}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Brands;
